import React from 'react';
import { Badge, type BadgeProps } from 'react-bootstrap';

type IStyledBadge = BadgeProps & { rpVariant: string };
export const StyledBadge = ({ rpVariant, ...props }: IStyledBadge) => {
  return (
    <Badge
      bg={
        rpVariant === 'rpi-completed'
          ? 'success'
          : rpVariant === 'rpi-yellow'
          ? 'warning'
          : rpVariant === 'rpi-red'
          ? 'danger'
          : undefined
      }
      pill
      {...props}
    />
  );
};
